import React,{useState} from 'react'
import "../App.css";
import { useNavigate } from "react-router-dom";

const Input = () => {
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };


  const firstpage = () => {
    navigate("/");
  };

  const secondpage = () => {
    if(inputValue.length === 0){
      alert("Please enter a valid key");
      return;
    }
    else{
    navigate('/page1', { state: { inputValue } });}
  };


  return (
    <>
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>In this page, the user has to enter an 8 character string which will further be used as a key for DES
      </p>
    </div>
    <div className="input-container">
      <div className="flex flex-col items-center">
        
        <div className="pt-10">
          <h1>Enter an 8 character string to use as a key for DES</h1>
          <br />

        </div>
        <div class="input-box">
        <input 
          maxLength="8" 
          className='border-solid border-3 bg-slate-100 px-2 py-2 rounded-md' 
          type="text"
          placeholder='Enter any alphanumeric value' 
          value={inputValue}
          onChange={handleChange}
          required />
          <br /><br />

        </div> 
        <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="next-button" onClick={secondpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Input